import classNames from 'classnames';
import React, { useMemo } from 'react';

import Slides from 'common/components/RewindModal/Slides';

import styles from '../styles.module.scss';
import BottomActions from './component/BottomActions';

type TopContentIntroProps = {
  entities: any;
  allScreens: any[];
  onNext: () => void;
  isLastStep: boolean;
  trackingScreenName?: string;
};

const TopContentIntro = ({
  entities,
  allScreens,
  onNext,
  isLastStep
}: TopContentIntroProps) => {
  const isSeries = useMemo(
    () => entities?.[0]?.identifier.includes('series'),
    [entities]
  );

  const flashbackType = useMemo(() => {
    const flashbackScreen = allScreens.find(s => s.name === 'flashback_type');
    return flashbackScreen?.data?.flashback_type;
  }, [allScreens]);

  const { title, subtitle } = useMemo(() => {
    const isGlobal = flashbackType === 6;

    if (isSeries) {
      return {
        title: 'Top séries',
        subtitle: isGlobal
          ? 'Elles ont duré des saisons… ou juste un soir. En 2025, elles ont marqué tous les écrans.'
          : 'Elles ont duré des saisons… ou juste un soir. En 2025, elles ont marqué votre écran.'
      };
    } else {
      return {
        title: isGlobal ? 'Top Films' : 'Top films',
        subtitle: isGlobal
          ? 'Pas besoin de jury : l’académie des cinéphiles AlloCiné a parlé'
          : 'Ils viennent d’hier, d’avant-hier ou de très loin.. et vous les avez validés en 2025'
      };
    }
  }, [isSeries, flashbackType]);

  return (
    <Slides>
      <div className={classNames(styles.contentLayout, styles.startLayout)}>
        <h2 className={styles.slideTitle}>{title}</h2>
        <h3 className={styles.slideText}>{subtitle}</h3>
      </div>
      <BottomActions
        showShare={false}
        showNext={!isLastStep}
        onNextClick={onNext}
      />
    </Slides>
  );
};

export default TopContentIntro;
